var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopWords(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79081 3.87868C3 4.75736 3 6.17157 3 9V15C3 17.8284 3 19.2426 3.79081 20.1213C4.58162 21 5.85442 21 8.4 21H15.6C18.1456 21 19.4184 21 20.2092 20.1213C21 19.2426 21 17.8284 21 15V9C21 6.17157 21 4.75736 20.2092 3.87868C19.4184 3 18.1456 3 15.6 3H8.4C5.85442 3 4.58162 3 3.79081 3.87868ZM15.6 8C16.0971 8 16.5 8.44772 16.5 9V17C16.5 17.5523 16.0971 18 15.6 18C15.1029 18 14.7 17.5523 14.7 17V9C14.7 8.44772 15.1029 8 15.6 8ZM9.3 11C9.3 10.4477 8.89706 10 8.4 10C7.90294 10 7.5 10.4477 7.5 11V17C7.5 17.5523 7.90294 18 8.4 18C8.89706 18 9.3 17.5523 9.3 17V11ZM12.9 13C12.9 12.4477 12.4971 12 12 12C11.5029 12 11.1 12.4477 11.1 13V17C11.1 17.5523 11.5029 18 12 18C12.4971 18 12.9 17.5523 12.9 17V13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopWords);
export default __webpack_public_path__ + "static/media/TopWords.6778383a.svg";
export { ForwardRef as ReactComponent };